import {
  deleteRequest,
  getRequest,
  postRequest,
} from '../../../../services/base'
import { useContext, useEffect, useRef, useState } from 'react'
import { NavContext } from '../../../../context/global_context'
import Pagination from '../../../common/Pagination'
import NoRecordsFound from '../../../common/NoRecordsFound'
import { createSearchParams, useParams } from 'react-router-dom'
import {
  PluginContext,
  SET_PLUGIN_DATA,
  SET_SELECTED_PLUGIN_DATA,
  SET_UPLOAD_GENERATE_FILE_STATUS,
  SHOW_DEF_BULK_UPLOAD,
} from './context/context'
import CreateUpdatePlugin from './form'
import PluginRow from './PluginsRow'
import LinkWithStatus from '../../../common/LinkWithStatus'
import PluginFilesViewer from './files'
import { FILE_CONFIG } from './constants'
import InputText from '../../../common/InputText'
import { Download, CloudUpload } from '@styled-icons/boxicons-solid'
import DropDownMenu from '../../../common/DropDownMenu'
import Button from '../../../common/Button'
import DefBulkUpload from './bulk_upload'
import { ProgresSpinner } from '../../../common/ProgresSpinner'
import { getSessionStorageData } from '../../../../utils/SessionStorage'

const DefPlugin = (props) => {
  const { vehicle } = useParams()
  const [state, dispatch] = useContext(NavContext)
  const [defPluginState, defPluginDispatch] = useContext(PluginContext)
  const [searchValue, setSearchValue] = useState('')
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    current_page: 1,
  })
  const [showModal, setShowModal] = useState(false)
  const [showFileViewerModal, setFileViewerModal] = useState(false)
  const currentUrl = useRef(null)

  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`

  useEffect(() => {
    getDefPluginList(null)
    fetchDefStatusInterval()

    dispatch({
      type: 'header',
      data: {
        header: 'Admin Tools',
        sub_header: `Vehicle List / ${vehicle} / Plugin / Def Plugin`,
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })

    const statusInt = setInterval(fetchDefStatusInterval, 10000)
    const defInterval = setInterval(getDefPluginList, 30000)

    return () => {
      clearInterval(statusInt)
      clearInterval(defInterval)
    }
  }, [])

  const fetchDefStatusInterval = async () => {
    let res = await getRequest(
      `/api/plugin/def/upload_status_check/${vehicle}/?vehicle=${vehicle}`
    )
    if (res?.status) {
      defPluginDispatch({
        type: SET_UPLOAD_GENERATE_FILE_STATUS,
        data: { ...res.data },
      })
    }
  }

  const getDefPluginList = async (url = null, showLoader = true) => {
    if (showLoader) {
      dispatch({
        type: 'loader',
        data: {
          caption: 'Fetching DEF Plugin Data',
          showLoader: true,
        },
        notification: {},
      })
    }

    let response = await getRequest(
      currentUrl.current
        ? currentUrl.current
        : `/api/plugin/def/?vehicle=${vehicle}&search=${searchValue}`
    )

    defPluginDispatch({ type: SET_PLUGIN_DATA, data: response.results })
    setPagination(response.pagination)
    dispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  const generateDefFiles = async (def_file_id) => {
    if (window.confirm('Are you sure want to generate files.') == true) {
      setFileViewerModal(false)
      dispatch({
        type: 'loader',
        data: {
          caption: 'Generation of DEF file is in progress..',
          showLoader: true,
        },
        notification: {},
      })

      let formData = new FormData()
      FILE_CONFIG.forEach((value, index) => {
        formData.append('file_types', value.key)
      })
      let res = await postRequest(
        `/api/plugin/def/generate_files/${def_file_id}/`,
        formData
      )
      dispatch({
        type: 'loader',
        data: {},
        notification: {},
      })
      fetchDefStatusInterval()
    }
  }

  const deleteDefFiles = async (def_file_id) => {
    if (window.confirm('Are you sure to delete Def file') == true) {
      dispatch({
        type: 'loader',
        data: {
          caption: 'Deleting Selected DEF ...',
          showLoader: true,
        },
        notification: {},
      })
      let res = await deleteRequest(
        `/api/plugin/def/${def_file_id}/?vehicle=${vehicle}`
      )
      getDefPluginList(null)
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'DEF files Successfully deleted!',
        },
      })
    }
  }

  const dropDownOnClick = async (option_value) => {
    if (
      ['generate_selected_files', 'generate_all_files'].includes(option_value)
    ) {
      let formData = new FormData()
      if (option_value == 'generate_all_files') {
        formData.append('generate_files', 'all')
      } else {
        defPluginState.selectedIds.forEach((element) => {
          formData.append('generate_files', element)
        })
      }

      let res = await postRequest(
        `/api/plugin/def/bulk_generate_files/${vehicle}/`,
        formData
      )
      if (res?.status) {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'DEF Generate file successfully started',
          },
        })
      }
    } else {
      downloadDefExportFile(option_value)
    }
  }

  const downloadDefExportFile = async (download_option = null) => {
    if (
      window.confirm(
        `Are you sure want to download ${download_option} DEF files`
      ) === true
    ) {
      dispatch({
        type: 'loader',
        data: {
          caption: 'Downloading Def files..',
          showLoader: true,
        },
        notification: {},
      })

      let formData = new FormData()
      if (download_option == 'All') {
        formData.append('def_files', 'All')
      } else {
        defPluginState.selectedIds.forEach((element) => {
          formData.append('def_files', element)
        })
      }
      formData.append('vehicle', vehicle)

      let res = await postRequest(
        `/api/plugin/def/bulk/download/`,
        formData,
        true
      )
      if (res?.msg) {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
            loader: true,
          },
        })
      } else {
        const url = window.URL.createObjectURL(new Blob([res]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${vehicle}_def.zip`)
        document.body.appendChild(link)
        link.click()
        link.remove()

        dispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'File downloaded successfully',
            loader: true,
          },
        })
      }
    }
  }

  return (
    <>
      {defPluginState?.show_bulk_upload && (
        <DefBulkUpload
          onClose={() => {
            getDefPluginList('')
          }}
        />
      )}
      <CreateUpdatePlugin
        showModal={showModal}
        setShowModal={setShowModal}
        getDefPluginList={getDefPluginList}
      />
      {showFileViewerModal && (
        <PluginFilesViewer
          showModal={showFileViewerModal}
          setShowModal={setFileViewerModal}
          generateDefFiles={generateDefFiles}
        />
      )}

      <div className="w-full">
        <form
          className="flex flex-col w-full space-y-2 pb-2"
          acceptCharset="UTF-8"
          onSubmit={(e) => {
            e.preventDefault()
          }}
        >
          <div
            className={`flex space-x-5 justify-between content-center items-center`}
          >
            <div className="flex items-center w-1/2">
              <div className="flex items-center w-full">
                <InputText
                  name="search_value"
                  placeholder={`Search Def Files By File Id or Description`}
                  className={`w-100`}
                  value={searchValue}
                  isFullSize={true}
                  type="search"
                  onChange={(value) => {
                    setSearchValue(value)
                  }}
                  isRequired={false}
                />
                <Button
                  className={`cursor-pointer btn my-4 justify-end`}
                  text={`Search`}
                  onClick={() => {
                    currentUrl.current = `/api/plugin/def/?vehicle=${vehicle}&search=${searchValue}`
                    getDefPluginList('')
                  }}
                />
              </div>
            </div>

            <div className="w-2/3 flex font-light text-right space-x-5 justify-end content-center items-center">
              {defPluginState?.in_process_upload_file_harnesses?.length > 0 && (
                <DropDownMenu
                  items={defPluginState?.in_process_upload_file_harnesses.map(
                    (progress_item, progress_index) => {
                      return {
                        name: `File Id :- ${progress_item}`,
                        value: progress_item,
                      }
                    }
                  )}
                  onClick={(item) => {}}
                  outsideClickClose={true}
                >
                  <LinkWithStatus
                    href={`/vehicles/${vehicle.vehicle_id}/edit`}
                    className="btn py-2 px-3 flex"
                    title="Download"
                    onClickFunc={() => {}}
                    key={`upload-def-file-link`}
                  >
                    <ProgresSpinner caption="File Upload In Progress" />
                    <CloudUpload
                      size="1.5rem"
                      color="white"
                      key={`upload-def-file-icon`}
                    />
                  </LinkWithStatus>
                </DropDownMenu>
              )}
              <DropDownMenu
                items={[
                  { name: 'Download All Files', value: 'All' },
                  {
                    name: 'Download Selected Files',
                    value: 'Download Selected Files',
                  },
                  {
                    name: 'Generate All Files',
                    value: 'generate_all_files',
                  },
                  {
                    name: 'Generate Selected Files',
                    value: 'generate_selected_files',
                  },
                ]}
                onClick={(item) => {
                  dropDownOnClick(item.value)
                }}
                showMenu={defPluginState?.selectedIds?.length > 0}
                key={`download-def-file`}
              >
                <LinkWithStatus
                  href={`/vehicles/${vehicle.vehicle_id}/edit`}
                  className="btn py-2 px-3"
                  title="Download"
                  onClickFunc={() => {}}
                  key={`download-def-file-link`}
                >
                  <Download
                    size="1.5rem"
                    color="white"
                    key={`download-def-file-icon`}
                  />
                </LinkWithStatus>
              </DropDownMenu>
              <LinkWithStatus
                href={`/administration/system/new`}
                className={
                  'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
                }
                title="Upload New File"
                onClickFunc={() => {
                  setShowModal(true)
                }}
              />
              <LinkWithStatus
                href={`/administration/system/new`}
                className={
                  'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
                }
                title="Upload Multiple Files"
                onClickFunc={() => {
                  defPluginDispatch({ type: SHOW_DEF_BULK_UPLOAD, data: true })
                }}
              />
            </div>
          </div>
        </form>
        <div className="font-light">
          <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
            <div className="flex w-1/12 items-center justify-center"></div>
            <div className="flex w-3/12 items-center">Harness Id</div>
            <div className="flex w-3/12 pl-6 items-center">Description</div>
            <div className="flex w-2/12 pl-6 items-center">Date</div>
            <div className="flex w-3/12 pl-6 items-center">Status</div>
          </div>
        </div>
        {defPluginState?.data?.map((plugin, index) => {
          return (
            <PluginRow
              {...plugin}
              key={`def-plugin-${index}`}
              onDelete={() => {
                deleteDefFiles(plugin.id)
              }}
              onViewFiles={() => {
                defPluginDispatch({
                  type: SET_SELECTED_PLUGIN_DATA,
                  data: { ...plugin, index: index },
                })
                setFileViewerModal(true)
              }}
              generateDefFiles={(def_file_id) => {
                generateDefFiles(def_file_id)
              }}
            />
          )
        })}
        {defPluginState?.data?.length < 1 && (
          <NoRecordsFound caption={'Def Plugin not found'} loading={false} />
        )}
        <div className="py-6">
          <Pagination
            context={pagination}
            onClickNext={(e) => {
              currentUrl.current = e
              getDefPluginList(e)
            }}
            onClickPrev={(e) => {
              currentUrl.current = e
              getDefPluginList(e)
            }}
          />
        </div>
      </div>
    </>
  )
}

export default DefPlugin
